(function () {
	// Verifica se jQuery è disponibile
	const jQueryAvailable = typeof $ !== 'undefined' && $ !== null;
	
	// Throttle function per ottimizzare le performance degli eventi scroll
	const throttle = (func, limit) => {
		let inThrottle;
		return function() {
			const args = arguments;
			const context = this;
			if (!inThrottle) {
				func.apply(context, args);
				inThrottle = true;
				setTimeout(() => inThrottle = false, limit);
			}
		}
	};

	const mediaBanner = () => {
		const mediaBanners = document.querySelectorAll(".media-banner");
		
		mediaBanners.forEach((block) => {
			let box = block.closest("section");
			let id = box.getAttribute("id");
			
			// Supporto sia jQuery che vanilla JS
			const stickyEffect = jQueryAvailable ? 
				$(block).data("sticky-effect") : 
				block.dataset.stickyEffect;

			if (stickyEffect) {
				var normalElement = document.querySelector(`#${id} + .sticky-section`);
				if (normalElement == null) {
					return;
				}

				var isSticky = false;

				// Funzione ottimizzata per lo scroll con throttling
				const handleScroll = throttle(function () {
					var stickyTop = box.getBoundingClientRect().top;
					var normalElementTop = normalElement.getBoundingClientRect().top;

					if (stickyTop <= 0 && !isSticky) {
						box.classList.add("sticky-active");
						isSticky = true;
					}

					if (normalElementTop <= 0 && isSticky) {
						box.classList.remove("sticky-active");
						isSticky = false;
					}
				}, 16); // ~60fps

				// Aggiungi listener con supporto per touch su mobile
				window.addEventListener("scroll", handleScroll, { passive: true });
				
				// Supporto specifico per dispositivi touch
				if ('ontouchstart' in window) {
					window.addEventListener("touchmove", handleScroll, { passive: true });
				}
			}
		});
	};

	// Funzione di debug per mobile (rimuovi in produzione)
	const debugMobile = () => {
		if (window.innerWidth <= 749) {
			console.log('Media Banner Debug - Mobile detected');
			console.log('jQuery available:', jQueryAvailable);
			console.log('Media banners found:', document.querySelectorAll(".media-banner").length);
			console.log('Sticky sections found:', document.querySelectorAll(".sticky-section").length);
		}
	};

	// Inizializzazione con controllo del DOM
	const init = () => {
		mediaBanner();
		debugMobile(); // Rimuovi in produzione
	};

	// Gestione dell'orientamento per mobile
	const handleOrientationChange = () => {
		// Attendi che l'orientamento si stabilizzi
		setTimeout(() => {
			mediaBanner();
		}, 300);
	};

	// Inizializzazione basata sullo stato del DOM
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	// Eventi Shopify
	document.addEventListener("shopify:section:load", init);
	
	// Gestione del cambio orientamento su mobile
	window.addEventListener('orientationchange', handleOrientationChange);
	
	// Fallback per resize su desktop
	let resizeTimeout;
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(mediaBanner, 250);
	});
})();

//document.addEventListener("DOMContentLoaded", function () {
//	var stickyElement = document.querySelector(
//		"#shopify-section-template--23032186601765__media-banner"
//	);
//	var normalElement = document.querySelector(
//		"#shopify-section-template--23032186601765__media-banner-2"
//	);
//	var isSticky = false; // Track whether the element is sticky

//	window.addEventListener("scroll", function () {
//		var stickyTop = stickyElement.getBoundingClientRect().top;
//		var normalElementTop = normalElement.getBoundingClientRect().top;

//		// Add sticky class when sticky element reaches the top of the viewport
//		if (stickyTop <= 0 && !isSticky) {
//			stickyElement.classList.add("sticky-active");
//			isSticky = true; // Set sticky state to true
//		}

//		// Remove sticky class if the second section is in the viewport
//		if (normalElementTop <= 0 && isSticky) {
//			stickyElement.classList.remove("sticky-active");
//			isSticky = false; // Set sticky state to false
//		}
//	});
//});
